import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";
import { AcessUser } from "../acess-view.component";

@Component({
    selector: 'app-companies-view',
    templateUrl: './companies-view.component.html',
    styleUrls: ['./companies-view.component.scss'],
    standalone: false
})
export class CompaniesViewComponent implements OnChanges {

  @Input() user: AcessUser;

  loadingDataCompany: boolean = false;
  companyInputFilter: string = "";
  companiesAcessData = [];
  selectedCompany: any = null;
  private filterTimer: any;

  constructor(private uas: UserAuthenticationServices) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.user != null && this.user != null) {
      this.companiesAcessData = [];
      this.selectedCompany = null;
      this.loadCompanies();
    }
  }

  loadCompanies() {
    let filter: any = this.companyInputFilter;
    if (filter == null || filter.length == 0) {
      filter = null;
    }

    this.loadingDataCompany = true;
    this.uas.getCompaniesAcessByUser(filter, this.user.id).then((x) => {
      this.companiesAcessData = this.uas.companiesArr;
      this.loadingDataCompany = false;
    });
  }

  updateFilterCompanies() {
    clearTimeout(this.filterTimer);
    this.filterTimer = setTimeout(() => this.loadCompanies(), 300);
  }

  clearFilter() {
    this.companyInputFilter = "";
    this.loadCompanies();
  }

  changeAcess(checked: boolean, item) {
    item.enable = checked;
    this.selectedCompany = item;

    this.uas.updateUserCompanyConfig(this.user.id, item.id, checked).then((x) => {
    });
  }
}
